import { gql } from '@apollo/client';
import type { VehicleDeviceAssociationInfoInput, VehicleDeviceAssociationInfoResponse } from '../../__generated__/graphql';
import graphQLRequester from '../../request/GraphQLRequester';

export class GraphQLVehicleDeviceAssociationRequester {
  public getVehicleDeviceAssociationsByDevice = (params?: VehicleDeviceAssociationInfoInput): Promise<VehicleDeviceAssociationInfoResponse> =>
    graphQLRequester
      .query<{ vehicleDeviceAssociationReportByDevice: VehicleDeviceAssociationInfoResponse }>({
        query: gql`
          query VehicleDeviceAssociationReportByDevice($input: VehicleDeviceAssociationInfoInput!) {
                vehicleDeviceAssociationReportByDevice(input: $input) {
                    count
                    associations {
                        fleetId
                        device {
                          id
                          cobliId
                        }
                        event
                        eventDate
                        duration
                        target
                        userEmail
                        vehicle {
                            id
                            licensePlate
                            tags {
                                name
                            }
                            groups {
                                id
                                name
                            }
                            operationalSituation {
                                id
                                targetType
                                targetId
                                situation
                                startsAt
                                endsAt
                                reason
                                active
                            }
                        }
                    }
                }
            }
        `,
        variables: {
          input: params,
        },
      })
      .then((result) => result.vehicleDeviceAssociationReportByDevice);

  public getVehicleDeviceAssociationsByVehicle = (params?: VehicleDeviceAssociationInfoInput): Promise<VehicleDeviceAssociationInfoResponse> =>
    graphQLRequester
      .query<{ vehicleDeviceAssociationReportByVehicle: VehicleDeviceAssociationInfoResponse }>({
        query: gql`
          query VehicleDeviceAssociationReportByVehicle($input: VehicleDeviceAssociationInfoInput!) {
                vehicleDeviceAssociationReportByVehicle(input: $input) {
                    count
                    associations {
                        fleetId
                        device {
                          id
                          cobliId
                        }
                        event
                        eventDate
                        duration
                        target
                        userEmail
                        vehicle {
                            id
                            licensePlate
                            tags {
                                name
                            }
                            groups {
                                id
                                name
                            }
                            operationalSituation {
                                id
                                targetType
                                targetId
                                situation
                                startsAt
                                endsAt
                                reason
                                active
                            }
                        }
                    }
                }
            }
        `,
        variables: {
          input: params,
        },
      })
      .then((result) => result.vehicleDeviceAssociationReportByVehicle);
}

export default GraphQLVehicleDeviceAssociationRequester;
